import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Form,
  Heading,
  HStack,
  SingleSelectField,
  SubmitButton,
} from '@medely/ui-kit';
import { FixedFooterLayout } from '../../components/FixedFooterLayout/FixedFooterLayout';
import { useCurrentUser } from '../../hooks';
import useLocationTypes from '../../hooks/useLocationTypes';
import useWorkHistories from '../../hooks/useWorkHistories';
// gonna use it next ticket PRO-2552
// import { EMPLOYMENT_TYPE_OPTIONS } from './constants';

const LoadingState = () => {
  return (
    <HStack justifyContent="center" alignItems="center">
      <CircularProgress />
    </HStack>
  );
};

export const WorkExperience = () => {
  const { currentUser, isLoading: currentUserLoading } = useCurrentUser();
  const { locationTypes, loading: locationTypesLoading } = useLocationTypes();
  // gonna use it next ticket PRO-2552
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { workHistories, isLoading: workHistoryLoading } = useWorkHistories();

  // gonna use it next ticket PRO-2552
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const locationTypeOptions = locationTypes.map(({ id, label }) => ({ value: id, label }));

  const getPositionsOptions = () => {
    const options: { value: number; label: string }[] = [];
    currentUser?.professional?.positions.map((position) => {
      options.push({
        value: position.id,
        label: position.display_name,
      });
    });
    return options;
  };

  const baseValuesLoading = currentUserLoading || locationTypesLoading || workHistoryLoading;
  const disableButtons = baseValuesLoading;

  return baseValuesLoading ? (
    <LoadingState />
  ) : (
    // Form fields will be add on next tickets PRO-2552
    <Form
      handleSubmit={function (): void {
        throw new Error('Function not implemented.');
      }}
      schema={undefined}
    >
      <FixedFooterLayout
        footerContent={
          <HStack>
            <Box mr={0.5} width="100%">
              <Button variant="outlined" disabled={disableButtons} fullWidth>
                Back
              </Button>
            </Box>
            <Box ml={0.5} width="100%">
              <SubmitButton disabled={disableButtons} fullWidth>
                Continue
              </SubmitButton>
            </Box>
          </HStack>
        }
      >
        <Box pb={2}>
          <Heading size="s" color="text.primary">
            Add detail for your most recent paid clinical experience in the U.S.
          </Heading>
        </Box>
        <SingleSelectField
          label="Most recent position"
          // check witch name use here PRO-2552
          name="user_position"
          options={getPositionsOptions()}
          placeholder="Select position"
        />
      </FixedFooterLayout>
    </Form>
  );
};
